import { render } from "./Sales.vue?vue&type=template&id=298207bf&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./custom-sales.scss?vue&type=style&index=0&id=298207bf&lang=scss&scoped=true"
import "./Sales.vue?vue&type=style&index=1&id=298207bf&lang=scss&scoped=true"
import "./Sales.vue?vue&type=style&index=2&id=298207bf&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298207bf"]])

export default __exports__